import React from "react";
import { useLocation } from "react-router-dom";
import { salaryData } from "./data";
import "../assests/CSS/SalaryBreakdown.css";

const SalaryBreakdown = () => {
  const location = useLocation();
  const searchData = location.state?.searchData || {};
  const selectedService = searchData.search || "EOR/PEO/AOR";
  const selectedCountry = searchData.location || "United States";

  const { title, subtitle, description, breakdown } = salaryData.getSalaryData(selectedService, selectedCountry);

  return (
    <div className="salary-breakdown__container">
      <div className="salary-breakdown__header">
        <h2 className="salary-breakdown__title">{title}</h2>
      </div>
      <p className="salary-breakdown__subtitle">{subtitle}</p>
      <p className="salary-breakdown__description">{description}</p>

      {breakdown && breakdown.length > 0 ? (
        <div className="salary-breakdown__cards">
          {breakdown.map((item, index) => (
            <div className="salary-breakdown__card" key={index}>
              <div className="salary-breakdown__card-header">
                <h3 className="salary-breakdown__card-title">{item.label}</h3>
                <div className="salary-breakdown__card-icon-wrapper">
                  <img
                    src={item.icon}
                    alt={item.label}
                    className="salary-breakdown__card-icon"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "/assets/images/placeholder-icon.png";
                    }}
                  />
                </div>
              </div>
              <p className="salary-breakdown__amount">{item.amount}</p>
              <div className="salary-breakdown__card-footer">
                {item.note && <p className="salary-breakdown__note">{item.note}</p>}
                {item.percent && <p className="salary-breakdown__percent">{item.percent}</p>}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="salary-breakdown__no-data">
          <p>No salary breakdown data available for {selectedService} in {selectedCountry}</p>
        </div>
      )}
    </div>
  );
};

export default SalaryBreakdown;